* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}
.overlay {
  .image-container {
    max-height: 110px;
    overflow: hidden;

    img {
      &.first-enrollment {
        transform: scale(1.1) translate(12px, -7px);
      }
      &.enrolled {
        transform: scale(1.1) translate(0px, 0px);
      }
    }
  }

  .title-container {
    padding: calc(var(--spacer) * 2.5) 0 calc(var(--spacer) * 2 - 1px) 0;
    .title {
      padding-right: calc(var(--spacer) - 2px);
      width: auto;
      .title-content {
        font-family: var(--font-family-secondary);
      }
      span.early {
        font-size: var(--body-size-xsmall);
        vertical-align: top;
      }
    }
  }

  .info-text-container {
    padding-bottom: calc(var(--spacer) * 3 + 3px);
    gap: calc(var(--spacer) * 2);
    .text-content {
      font-family: var(--font-family-secondary);
    }
  }

  .action-buttons {
    gap: var(--spacer);
  }
}

gz-text,
gz-title {
  color: var(--white-layout-300-primary);
}
